function fallbackAvatar() {
    return '/images/default/avatar.svg';
}

function resolveActorAvatar(actor) {
    if (actor?.avatar && actor.avatar !== 'gravatar') {
        return actor.avatar;
    }

    if (actor?.gravatar) {
        return actor.gravatar;
    }

    return fallbackAvatar();
}

function resolveActorName(actor) {
    if (actor?.name) {
        return String(actor.name);
    }

    return 'Unbekannt';
}

export function cmsCreatedActorAvatar(item) {
    if (item?.is_system) {
        return null;
    }

    return resolveActorAvatar(item?.created_by_user || null);
}

export function cmsCreatedActorName(item) {
    if (item?.is_system) {
        return '–';
    }

    return resolveActorName(item?.created_by_user || null);
}

export function cmsPublishedActorAvatar(item) {
    return resolveActorAvatar(item?.published_by_user || null);
}

export function cmsPublishedActorName(item) {
    return resolveActorName(item?.published_by_user || null);
}

export function cmsUpdateActorAvatar(item) {
    const actor = item?.updated_by_user || null;

    return resolveActorAvatar(actor);
}

export function cmsUpdateActorName(item) {
    const actor = item?.updated_by_user || null;

    return resolveActorName(actor);
}
